import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";

type TFormBuilderTextareaType = "textarea";
export type TFormBuilderTextareaRole = "custom" | "message";

export interface IFormBuilderTextareaSettings {
  label: string;
  placeholder: string;
  required: boolean;
}

export interface IFormBuilderTextareaData extends IFormBuilderItemDataBase {
  type: TFormBuilderTextareaType;
  role: TFormBuilderTextareaRole;
  settings: IFormBuilderTextareaSettings;
}

export interface IFormBuilderTextarea extends IFormBuilderItemBase {
  data: IFormBuilderTextareaData;
}

export type TFormBuilderTextareaSettings = IFormBuilderTextarea["data"]["settings"];

export function isFormBuilderTextareaItem(item: TFormBuilderItem): item is IFormBuilderTextarea {
  return item.data.type === "textarea";
}

export function isFormBuilderTextareaType(value: string): value is TFormBuilderTextareaType {
  return value === "textarea";
}

export function isFormBuilderTextareaRole(value: string): value is TFormBuilderTextareaRole {
  return value === "custom" || value === "message";
}

export function formBuilderGenerateDefaultMessageTextarea(): IFormBuilderTextarea {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "textarea",
      role: "message",
      settings: {
        label: "Message", // TODO: Translation
        placeholder: "Add your message", // TODO: Translation
        required: true,
      },
    },
  };
}

export function formBuilderGenerateDefaultCustomTextarea(): IFormBuilderTextarea {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "textarea",
      role: "custom",
      settings: {
        label: "Textarea", // TODO: Translation
        placeholder: "Add your text", // TODO: Translation
        required: true,
      },
    },
  };
}
